import { useState } from 'react';
import { AnalyticsNumBedroomType } from '@zg-rentals/ts-customer-analytics-client';

export enum VacantUnitsFilter {
  PORTFOLIO = 'Portfolio',
  MARKET = 'Market',
}

export const useMarketDataFilters = () => {
  const [mfBedsFilter, setMfBedsFilter] = useState<AnalyticsNumBedroomType>(AnalyticsNumBedroomType.ALL);
  const [sfBedsFilter, setSfBedsFilter] = useState<AnalyticsNumBedroomType>(AnalyticsNumBedroomType.ALL);
  const [vacantUnitsFilter, setVacantUnitsFilter] = useState<VacantUnitsFilter>(VacantUnitsFilter.PORTFOLIO);

  return {
    mfBedsFilter,
    setMfBedsFilter,
    sfBedsFilter,
    setSfBedsFilter,
    vacantUnitsFilter,
    setVacantUnitsFilter,
  };
};
